import React from 'react';
import { Languages } from 'lucide-react';
import { useLang, Lang } from '../contexts/LanguageContext';
type Props = {
  className?: string;
};
export function LanguageToggle({
  className = ''
}: Props) {
  const {
    lang,
    setLang,
    t
  } = useLang();
  const options: Lang[] = ['es', 'en'];
  return <div className={`inline-flex items-center gap-1 rounded-full border border-white/15 bg-dark-100/80 p-1 ${className}`} role="group" aria-label={t.language.label} data-id="element-171" data-mp="2t78pf2w233v5">
      <Languages className="w-3.5 h-3.5 text-gray-500 ml-1.5" aria-hidden="true" data-id="element-172" data-mp="21guhroemynrx" />
      {options.map(option => <button key={option} onClick={() => setLang(option)} aria-pressed={lang === option} className={`px-2.5 py-1 rounded-full text-xs font-bold tracking-wide transition-colors ${lang === option ? 'bg-gold text-dark' : 'text-gray-400 hover:text-white'}`} data-id="element-173" data-mp="2f88z7qswagwv">
          {option.toUpperCase()}
        </button>)}
    </div>;
}